export const lang = {
    genesis:"创世区块已产出",
    images: {
        tri: "tri-zh-CN.png",
        tps: "what-tps-zh-CN.png"
    },
    banner: {
        helixTitle: "HELIX 1.0",
        days: "Days",
        hours: "Hours",
        minutes: "Minutes",
        seconds: "Seconds",
        blockConfirmationTime: "区块时间0.5秒",
        lowTransferFee: "低转账费0.01 DNA",
        highTps: "每秒10,000+次交易",
        moreInfoBtn: "更多主网信息",
        goToExplorer: "进入浏览器",
        b2t1: "DNA",
        b2c1: "链基于DPoS共识算法运行",
        b2t2: "DNA",
        b2c2: "将保持去中心化，同时允许接近立刻的交易并整合面向未来的数字金融生态系统所需的所有功能",
        network: "Network",
        architecture: "Architecture",
        findOutMore: "发现更多"
    },
    navs: {
        explores: '区块浏览器',
        wallets: '钱包',
        bounty: '赏金平台',
        build: '使用元界DNA',
        what: '什么是元界DNA?',
        mainnet: 'Helix 1.0',
        invest: '投资DNA',
        development: '开发者资源',
        download: '节点程序下载',
        community: '社区生态',
        connect: '联系我们',
        global: '大使计划',
        institute: 'DNA区块链研究院',
        aboutInstitute: '关于研究院',
        open: '开放技术标准',
        funding: '资金和补贴',
        testnet: '测试网',
        testnet_explorer: '测试网区块浏览器',
        testnet_dex: '去中心化交易所',
        testnet_faucet: '测试网水龙头',
    },
    about: [
        {
            title: '关于DNA',
            text: '了解元界DNA以和应用，立刻体验元界DNA网络的易用性和速度。',
            url: 'what',
            btn: '了解更多'
        },
        {
            title: '使用资源',
            text: '使用元界DNA背后的技术及其应用，以便您开始使用它进行构建和开发。',
            url: 'development',
            btn: '开始使用'
        },
        {
            title: '社区生态',
            text: '如何加入DNA生态并通过您的成就获得奖励。',
            url: 'connect',
            btn: '加入我们'
        }
    ],
    comingsoon: "敬请期待！",
    learn: '查看更多',
    rapid: {
        title: '下一代公链的5个关键点',
        btn: '了解元界DNA更多信息'
    },
    metaverse: '元界DNA白皮书',
    metaText: '元界DNA技术概述以及现代分布式金融基础架构的原始设计',
    metaBtn: '元界DNA白皮书',
    community: '订阅我们的邮件列表',
    comText: '想保持所有节点和协议更改，网络更新详细信息，社区更新和新闻吗？ 订阅我们的邮件列表',
    mailPlace: '输入邮箱地址',
    comBtn: '订阅',
    comBtnJoin: '成功',
    exchange: '元界DNA是金融技术2.0的基石，它具有无与伦比的安全性，最先进的数字资产，通用的数字身份以及下一代去中心化交易所。',
    contact: '联系我们',
    reserved: '© 2020 Metaverse. All Rights Reserved.',
    emailGeneralTitle: '联系我们',
    emailGeneral: "contact@mvsdna.com",
    emailMediaTitle: '商务合作',
    emailMedia: "press@mvsdna.com",
    dev: {
        start: '开始使用DNA',
        details: "在这里，开发者可以浏览全面的指南和文档，以帮助您尽快开始使用DNA，并在遇到困难时提供支持。 让我们开始吧！",
        btn: '开始使用',
        docs: 'DNA文档',
        docDetails: '涵盖API，集成指南，协议设计等的常规文档。',
        github: 'Github',
        githubDetails: '与我们的开发人员社区见面，以探索，共享和构建',
        testnet: '测试网',
        testnetDetails: '获得免费的testnet DNA，用于开发和测试应用程序',
        whitepaper: '白皮书',
        whitepaperDetails: '元界DNA技术概述以及现代分布式金融基础架构的原始设计'
    },
    what: {
        title: '什么是元界DNA?',
        text1: '随着分布式分类账本技术进入其第二个十年，分布式平台的范围广泛，旨在提供特定功能。 但是，所有这些都是独立的，互斥的专有平台。 如果要真正实现采用，下一代公共区块链将需要在一个地方无缝地整合这些功能。',
        text2: '双链网络体系结构（DNA）就是为此目的而设计的。 由DNA令牌驱动的第二条链将基于委托的权益证明共识算法进行操作。',
        btn: '元界DNA白皮书',
        features: {
            title: '进阶功能',
            subtitle1: '治理结构',
            subtext1: 'DNA将在三层节点结构上运行。 子节点将其下注权力委托给普通节点，这些普通节点确认区块并返回其代表的区块奖励部分。 普通节点选择或替换超级节点，由超级节点对提案修订和升级进行投票。 任何人都可以为权力下放的治理做出贡献，无论其持股或技术专长如何。',
            subtitle2: '闪电交易',
            subtext2: 'DNA在超级节点和普通节点之间具有预先建立的闪电通道。',
            subtext3: '如果参与者拥有通往这些节点中任何一个的开放通道，他们将享受闪电般的快速交易和最低的费用。',
            super: '超级',
            regular: '普通',
            child: '子',
            nodes: '节点'
        },
        token: {
            title: '什么是DNA代币？',
            text1: 'DNA是元界DNA的链上通证，它是一种数字资产，可以通过网络轻松，安全，即时地发送。 它也是区块链生态系统的重要组成部分，将在基于元界的应用程序中使用。',
            text2: '您可以通过访问我们官方认可的加密货币交易所之一轻松地对DNA进行',
            text3: '是否想知道一旦拥有即可存储您的DNA？ 注册一个',
            text4: '想追踪您的DNA转账记录吗？ 使用我们的',
            span2: '投资。',
            span3: '元界DNA钱包。',
            span4: '元界DNA区块浏览器。'
        },
        version: 'Helix 1.0 版本',
        versionText: '我们很荣幸发布元界DNA主网的第一个版本。 这是整个元界团队，开发人员，投资者，顾问以及最重要的是整个元界DNA社区多年来辛勤工作的结晶，这些人迄今为止一直在支持我们。',
        tps: '每秒交易量 (TPS)',
        higher: 'TPS比市场竞争对手高得多',
        time: '出块时间',
        digital: '数字身份',
        simple: '简单的帐户设置和易于使用的Metaverse DNA转账',
        price: '每笔交易成本价',
        according: '*根据2020年7月16日的价格',
        read: '查看我们的白皮书',
        map: 'DNA路线图'

    },
    connect: {
        tit1: '元界DNA社区',
        text1: '元界DNA社区包括全世界的开发人员，技术人员，用户，持有者和爱好者。 参与DNA社区的方式有很多：您可以参加活动，加入小组或为项目做贡献。',
        tit2: '最新博客',
        tit3: '成为DNA全球大使',
        text3: 'DNA全球大使计划最高可达100万美金等价的DNA。 展示卓越品质和成就的大使将被授予“ DNA全球大使”的荣誉称号。 DNA大使有可能获得无限的基于绩效的奖励。 奖励系统分为三个级别，分别具有相应的奖励金额和收益。',
        objectives: '目标',
        o1: '建立并提高对元界DNA项目的认识，共享有关元界DNA及其生态系统的信息',
        o2: '为与当地企业，组织和社区的潜在合作机会提供必要的支持',
        o3: '帮助建立本地元界DNA社区',
        system: '奖励系统',
        table: [
            { t1: '等级', t2: '称号', t3: 'Maximum Reward (Monthly)' },
            { t1: '1', t2: '全球大使', t3: '1200 USD - Unlimited' },
            { t1: '2', t2: '领航员', t3: '800 USD' },
            { t1: '3', t2: '布道者', t3: '500 USD' }
        ],
        tit4: '开始申请',
        text4: '完成下面的快速申请，如果您的个人资料与职位匹配，我们将与您联系以完成招聘过程。',
        btn: '开始申请',
        partners: '媒体合作伙伴',
        exchanges: '交易所',
        backers: '投资机构'
    },
    dbi: {
        banner: 'DNA区块链研究所是一个包容性的区块链组织，其目的是引入新标准并推动公共区块链行业的创新。 我们的社区由杰出的开发人员，企业家，技术梦想家和终身学习者组成。 我们欢迎有兴趣改进当前公共区块链标准以推动区块链采用的任何人。',
        total: '总资金',
        learn: '1.5亿美元',
        open: '开放技术标准（OTS）',
        unresolved: '当前公链的未解决问题',
        list: [
            '缺乏性能',
            '高使用成本',
            '交易费用制度的局限性',
            '公链生存在“孤岛”上'
        ],
        text: [
            '为了解决公链的问题，现在是时候在一起为区块链行业的更大利益而团结起来。',
            '通过仔细检查派生和研究基础，但不限制公共链的开发框架，任何不同框架的开发团队都可以根据开放技术标准（OTS）进行开发',
            '开发过程是各种框架之间健康竞争的保证。 在相同的开放标准下，DNA区块链研究所的顾问将评估所有开发团队。'
        ],
        go: '查看OTS白皮书',
        sign: '注册电子邮件以获得新消息和合作机会',
        fund: [
            {
                tit: '资金和补贴',
                text: 'DBI将为支持元界DNA生态系统并对元界DNA协议做出突出贡献的组织和项目提供两类资助:'
            },
            {
                tit: '技术补贴:',
                text: '旨在促进围绕元界DNA协议的开发工作，以及促进其集成到不同的公共区块链开发人员社区。赠款可用于引入元体DNA的一流标准，并实施元界DNA改进建议。'
            },
            {
                tit: '生态补贴：',
                text: '旨在鼓励开发人员基于我们一流的基础设施构建应用程序和业务。最初，我们将主要关注DeFi应用程序。然而，我们也欢迎开发其他分散的应用程序，因为它们可以为我们的生态系统增加价值。'
            }
        ],
        proposal: '方案评估',
        ptxt: '我们将仔细评估每一份提案，并采用透明的审查程序，以决定谁有资格获得研究所的财政支持。',
        the: '建议的评估过程将按下列方式进行:',
        call: '提出申请',
        initial: '初步提案审查和尽职调查',
        official: '官方批准',
        start: '开始申请',
        about: '关于我们',
        atxt: '由元界DNA资助创建的DNA区块链研究院(DBI)将为整个行业的利益创建行业报告和见解，并监督DNA链和生态系统的整个未来发展',
        a1: '深入理解每个区块链协议。',
        a2: '根据严格的学术要求定义标准。',
        a3: '以独特的价值主张向所有公共区块链开放我们自己。',
        a4: '开发高度的商业智慧，促进区块链之间的互操作性，以实现高价值的商业用例。'
    }
}



// WEBPACK FOOTER //
// ./src/common/lang/cn.js